(() => {
  const initTabsBlog = (tabsRoot) => {
    if (!tabsRoot) return;

    const pageSize = Math.max(1, Number.parseInt(tabsRoot.dataset.pageSize || '6', 10));
    const panels = Array.from(tabsRoot.querySelectorAll('.tabs-blog__panel'));

    const updatePanel = (panel, nextPage) => {
      if (!panel) return;
      const items = Array.from(panel.querySelectorAll('.tabs-blog__item'));
      const pager = panel.querySelector('.tabs-blog__pagination');
      if (!items.length || !pager) return;

      const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
      const page = Math.min(totalPages, Math.max(1, nextPage || Number.parseInt(panel.dataset.page || '1', 10)));
      panel.dataset.page = String(page);

      const start = (page - 1) * pageSize;
      const end = start + pageSize;
      items.forEach((item, index) => {
        item.hidden = index < start || index >= end;
      });

      if (totalPages <= 1) {
        pager.innerHTML = '';
        pager.hidden = true;
        return;
      }

      pager.hidden = false;
      const prevDisabled = page === 1 ? 'disabled' : '';
      const nextDisabled = page === totalPages ? 'disabled' : '';

      let pagesHtml = '';
      for (let i = 1; i <= totalPages; i += 1) {
        pagesHtml += `<button class="tabs-blog__page-btn${i === page ? ' is-active' : ''}" data-page="${i}" aria-label="Page ${i}">${i}</button>`;
      }

      pager.innerHTML = `
        <button class="tabs-blog__page-btn tabs-blog__page-btn--nav" data-page="${page - 1}" ${prevDisabled}>Prev</button>
        ${pagesHtml}
        <button class="tabs-blog__page-btn tabs-blog__page-btn--nav" data-page="${page + 1}" ${nextDisabled}>Next</button>
      `;
    };

    panels.forEach((panel) => updatePanel(panel, 1));

    tabsRoot.addEventListener('click', (event) => {
      const pageBtn = event.target.closest('.tabs-blog__page-btn');
      if (!pageBtn || pageBtn.disabled) return;
      const panel = pageBtn.closest('.tabs-blog__panel');
      if (!panel) return;
      const targetPage = Number.parseInt(pageBtn.dataset.page || '1', 10);
      updatePanel(panel, targetPage);
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    tabsRoot.addEventListener('tabChange', (event) => {
      const selected = event.detail && event.detail.selectedTab;
      if (!selected) return;
      updatePanel(selected, Number.parseInt(selected.dataset.page || '1', 10));
    });
  };

  const init = () => {
    document.querySelectorAll('.tabs-blog').forEach((tabsRoot) => initTabsBlog(tabsRoot));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
